import { isEqual, cloneDeep } from 'lodash'

export default {
  data() {
    return {
      successRedirect: false,
      form: {},
      formCopy: {}
    }
  },
  beforeDestroy() {
    window.onbeforeunload = () => {}
  },
  beforeRouteLeave(to, _, next) {
    if (this.successRedirect || isEqual(this.formCopy, this.form)) return next()

    next(false)

    this.$confirm('Czy na pewno chcesz opuścić stronę bez zapisania?', {
      closeOnHashChange: false
    })
      .then(() => {
        this.successRedirect = true
        this.$router.push(to.fullPath)
      })
      .catch(() => {})
  },
  methods: {
    prepareFormCopyToPreventChangesLost() {
      this.formCopy = cloneDeep(this.form)

      window.onbeforeunload = () => {
        if (isEqual(this.formCopy, this.form)) {
          return null
        } else {
          return true
        }
      }
    },
    instanceFetchCallback() {
      this.prepareFormCopyToPreventChangesLost()
    }
  }
}
